import components from "./components/lang.en";
import layouts from "./layouts/lang.en";
import store from "./store/lang.en";
export default {
	"teaming-web": {
		components,
		layouts,
		store,
		routes: {
			teamingRoute: "{title} {'|'} Opre",
		},
	},
};
